<template>
    <div class="pointer" @click="openSidebar">
        <slot />
    </div>
</template>

<script>
/**
 * When the user clicks on this component, the given sidebar area will open.
 * This functionality can be enabled or disabled as needed.
 */
export default {
    name: "ASidebar",
    props: {
        enabled: {type: Boolean, default: true},
        area: {type: String, required: true},
    },

    computed: {
        isViable() {
            return Boolean(this.enabled && this.area);
        }
    },

    methods: {
        openSidebar(e) {
            if (!this.isViable) {
                return;
            }

            e.preventDefault();

            this.$emit('beforeopen');
            this.$root.sidebar(this.area);
            this.$emit('opened');
        }
    }
}
</script>

<style scoped>
.pointer { cursor: pointer; }
</style>
